import { Field } from "formik";
import get from "lodash/get";
import { useState } from "react";
import deleteIcon from "../../assets/icons/delete-bin.svg";

export const FormMultiImageVideoField = ({
  name = "media",
  label = "Media Upload",
  uploadIcon,
  addCoverIcon,
  uploadPlaceholder,
  className = "",
  ...props
}) => {
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragIndex, setDragIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [uploadStatuses, setUploadStatuses] = useState([]);
  const [isDragActive, setIsDragActive] = useState(false);
  const [onErrorOpen, setOnErrorOpen] = useState(false);
  const [onErrorMessage, setOnErrorMessage] = useState(
    "Some files exceed 100MB and were not uploaded"
  );

  const handleFileChange = async (event, setFieldValue, values) => {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) return;

    const MAX_SIZE = 100 * 1024 * 1024;

    const oversizedFiles = files.filter((file) => file.size > MAX_SIZE);
    const validFiles = files.filter((file) => file.size <= MAX_SIZE);

    if (oversizedFiles.length > 0) {
      const fileNames = oversizedFiles.map((f) => f.name).join(", ");
      //   setOnErrorMessage(
      //     `The following files exceed 100MB and were not uploaded:\n${fileNames}`
      //   );
      //   setOnErrorOpen(true);
      //   setTimeout(timeOutFnc, 3000);
    }

    if (validFiles.length === 0) return;

    const newStatuses = validFiles.map((file, idx) => ({
      id: `${Date.now()}-${idx}`,
      file,
      status: "loading",
      progress: 0,
      url: null,
      previewUrl: URL.createObjectURL(file),
      type: file.type.startsWith("image/") ? "image" : "video",
    }));

    setUploadStatuses((prev) => [...prev, ...newStatuses]);

    const uploadPromises = newStatuses.map(
      (status) =>
        new Promise((resolve) => {
          const formData = new FormData();
          formData.append("file", status.file);

          const xhr = new XMLHttpRequest();

          xhr.upload.addEventListener("progress", (e) => {
            if (e.lengthComputable) {
              const percentComplete = Math.round((e.loaded / e.total) * 100);
              setUploadStatuses((prev) =>
                prev.map((s) =>
                  s.id === status.id ? { ...s, progress: percentComplete } : s
                )
              );
            }
          });

          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
              if (xhr.status >= 200 && xhr.status < 300) {
                const response = JSON.parse(xhr.responseText);
                const url = response.data.filePath;
                const type = status.file.type.startsWith("image/")
                  ? "image"
                  : "video";

                setUploadStatuses((prev) =>
                  prev.map((s) =>
                    s.id === status.id
                      ? {
                          ...s,
                          progress: 100,
                          status: "done",
                          url: url,
                          type: type,
                          checked: false,
                          alt:""
                        }
                      : s
                  )
                );

                resolve({ url, type, checked: false, alt:"" });
              } else {
                setUploadStatuses((prev) =>
                  prev.map((s) =>
                    s.id === status.id ? { ...s, status: "error" } : s
                  )
                );
                resolve(null);
              }
            }
          };

          xhr.open(
            "POST",
            "https://api-new.requal.in/api/image/upload-image"
          );
          xhr.send(formData);
        })
    );

    const uploadedResults = await Promise.all(uploadPromises);
    const successfulUploads = uploadedResults.filter(Boolean);

    var statuses = [...uploadStatuses];
    for (let index = 0; index < successfulUploads.length; index++) {
      const element = successfulUploads[index];
      statuses = statuses.filter((s) => s.url == element.url);
    }
    setUploadStatuses([...uploadStatuses, ...statuses]);

    const currentMedia = values[name] ? [...values[name]] : [];
    const updatedMedia = [...currentMedia, ...successfulUploads].map(
      (item, index) => ({
        ...item,
        index,
      })
    );

    setFieldValue(name, updatedMedia);
  };

  const handleDelete = (index, setFieldValue, values) => {
    const newMedia = [...values[name]];
    newMedia.splice(index, 1);
    setFieldValue(name, newMedia);
  };

  const handleDragStart = (index) => setDraggedIndex(index);
  const handleDragOver = (e) => e.preventDefault();

  const handleDrop = (index, values, setFieldValue) => {
    if (draggedIndex === null || draggedIndex === index) return;
    const updatedItems = [...values[name]];
    const draggedItem = updatedItems.splice(draggedIndex, 1)[0];
    updatedItems.splice(index, 0, draggedItem);
    setFieldValue(name, updatedItems);
    setDraggedIndex(null);
  };

  const handleTouchStart = (index) => setDragIndex(index);

  const handleTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    const elements = document.querySelectorAll("[data-draggable-index]");

    let closestIndex = null;
    let closestDistance = Infinity;

    elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const index = Number(el.getAttribute("data-draggable-index"));
      const centerY = rect.top + rect.height / 2;
      const distance = Math.abs(touch.clientY - centerY);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    if (closestIndex !== null && closestIndex !== hoverIndex) {
      setHoverIndex(closestIndex);
    }
  };

  const handleTouchEnd = (values, setFieldValue) => {
    if (dragIndex !== null && hoverIndex !== null && dragIndex !== hoverIndex) {
      const newMedia = Array.from(values[name]);
      const [movedItem] = newMedia.splice(dragIndex, 1);
      newMedia.splice(hoverIndex, 0, movedItem);
      setFieldValue(name, newMedia);
    }
    setDragIndex(null);
    setHoverIndex(null);
  };

  const handleCheckBox = (index, setFieldValue, values, checked) => {
    console.log(index, values, checked);

    const newMedia = [...values[name]];
    newMedia[index].checked = checked;
    setFieldValue(name, newMedia);
  };

  const handleALTText = (index, setFieldValue, values, inputValue) => {
    console.log(index, values, inputValue);

    const newMedia = [...values[name]];
    newMedia[index].alt = inputValue;
    setFieldValue(name, newMedia);
  };


  const handleFileDrop = (e, setFieldValue, values) => {
    e.preventDefault();
    e.stopPropagation();

    if (draggedIndex !== null) return; // avoid reorder conflict

    const files = Array.from(e.dataTransfer.files || []);
    handleFileChange({ target: { files } }, setFieldValue, values);

    setIsDragActive(false);
  };

  const handleDropReorder = (index, values, setFieldValue) => {
    if (draggedIndex === null || draggedIndex === index) return;

    const updated = [...values[name]];
    const [moved] = updated.splice(draggedIndex, 1);
    updated.splice(index, 0, moved);

    setFieldValue(name, updated);
    setDraggedIndex(null);
  };

  return (
    <Field name={name}>
      {({ form, meta }) => {
        const values = form.values;
        const mediaItems = get(values, name) || [];
        console.log("mediaItems", mediaItems);

        return (
          <div className={`rounded-lg ${className}`}>
            <div className="flex justify-between items-center my-2">
              <p className="text-lg font-medium">{label}</p>
              {mediaItems.length > 0 && (
                <label className="cursor-pointer text-white bg-primary px-4 py-2 rounded-lg">
                  Add Media
                  <input
                    type="file"
                    multiple
                    accept="image/*,video/*"
                    className="hidden"
                    onChange={(e) =>
                      handleFileChange(e, form.setFieldValue, values)
                    }
                  />
                </label>
              )}
            </div>
            <div
              onDragOver={(e) => {
                e.preventDefault();
                setIsDragActive(true);
              }}
              onDragLeave={() => setIsDragActive(false)}
              onDrop={(e) => handleFileDrop(e, form.setFieldValue, values)}
              className={`my-2 border-[1px] border-lightBg rounded-xl p-3 overflow-x-hidden bg-white  ${
                mediaItems?.length > 0 || uploadStatuses?.length > 0
                  ? "h-fit"
                  : "h-[30rem] flex justify-center items-center"
              }`}
            >
              {(mediaItems?.length > 0 || uploadStatuses?.length > 0) && (
                <div
                  className={`grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4`}
                >
                  {mediaItems.map((item, index) => (
                    <div
                      key={index}
                      data-draggable-index={index}
                      draggable
                      onDragStart={() => handleDragStart(index)}
                      onDragOver={handleDragOver}
                      onDrop={() =>
                        handleDrop(index, values, form.setFieldValue)
                      }
                      onTouchStart={() => handleTouchStart(index)}
                      onTouchMove={handleTouchMove}
                      onTouchEnd={() =>
                        handleTouchEnd(values, form.setFieldValue)
                      }
                      className={`relative w-[250px] max-w-[190px]  overflow-hidden border ${
                        hoverIndex === index
                          ? "border-blue-500"
                          : "border-lightBg"
                      }`}
                    >
                      <div className={`relative w-[250px] max-w-[190px] h-[190px] rounded-lg overflow-hidden border ${
                        hoverIndex === index
                          ? "border-blue-500"
                          : "border-lightBg"
                      }`}>

                      {item.type === "image" ? (
                        <img
                          src={item.url}
                          alt={`media-${index}`}
                          className="w-full h-full object-cover"
                          width={800}
                          height={600}
                        />
                      ) : (
                        <video controls className="w-full h-full object-cover">
                          <source src={item.url} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      )}
                      <div
                        className="absolute top-2 right-2 bg-errorColor p-1 rounded-full shadow cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(index, form.setFieldValue, values);
                        }}
                      >
                        <img src={deleteIcon} width={14} height={14} />
                      </div>
                      <label
                        className="absolute top-2 left-2 z-10 bg-white/90 rounded-md flex items-center justify-center shadow-sm"
                        aria-label={`Select media-${index}`}
                      >
                        <input
                          type="checkbox"
                          checked={item.checked}
                          onChange={(e) => {
                            handleCheckBox(
                              index,
                              form.setFieldValue,
                              values,
                              e.target.checked
                            );
                            var v = e.target.checked;
                          }}
                          className="w-4 h-4 md:w-5 md:h-5 accent-primary cursor-pointer"
                        />
                      </label>
                      </div>

                      <div className={`flex flex-col gap-1 col-span-3 ${className}`}>
                                    <input
                                      id={`media-alt--${index}`}
                                      name={`media-alt--${index}`}
                                      value={item.alt}
                                      onChange={(e) => {
                                         handleALTText(
                                          index,
                                          form.setFieldValue,
                                          values,
                                          e.target.value
                                        );
                                      }}
                                      className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                                                      text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                                        required
                                    />
                                  </div>
                    </div>
                  ))}

                  {uploadStatuses
                    .filter((status) => status.status == "done")
                    .map((status, index) => (
                      <div
                        key={index}
                        className="relative w-[250px] max-w-[190px] h-[190px] rounded-lg"
                      >
                        <div className="bg-white w-full h-full shadow cursor-move">
                          {status?.type === "image" ? (
                            <img
                              src={status.url}
                              alt={`Media uploaded`}
                              className="w-full h-full object-cover rounded-lg"
                              width={2000}
                              height={2000}
                            />
                          ) : (
                            <video
                              controls
                              className="w-full h-full object-cover rounded-lg"
                            >
                              <source src={status.url} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          )}
                        </div>
                        {status?.type === "video" && (
                          <label className="bg-lightBg text-fs_10 absolute top-0 left-1 px-1 rounded-md my-1 font-fw_500">
                            Video
                          </label>
                        )}
                      </div>
                    ))}

                  {uploadStatuses
                    .filter((status) => status.status !== "done")
                    .map((status) => (
                      <div
                        key={status.id}
                        className="w-[250px] max-w-[190px] h-[190px] rounded-lg relative"
                      >
                        <div className="">
                          {status.type === "image" ? (
                            <img
                              src={status.previewUrl}
                              alt="preview"
                              className="absolute inset-0 w-full h-full object-cover scale-105 blur-[3px] rounded-lg "
                            />
                          ) : (
                            <video
                              src={status.previewUrl}
                              className="absolute inset-0 w-full h-full object-cover scale-105 blur-[3px] rounded-lg "
                              muted
                              autoPlay
                              loop
                            />
                          )}
                        </div>
                        {status.status === "loading" ? (
                          <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
                            <p className="text-sm mb-2 font-medium">
                              Uploading...
                            </p>

                            <div className="w-full max-w-[180px] bg-white/40 rounded-full h-[6px] overflow-hidden shadow">
                              <div
                                className="h-full rounded-full transition-all duration-200"
                                style={{
                                  width: `${status.progress}%`,
                                  background:
                                    "linear-gradient(to right, #00e676, #1e9d43)",
                                }}
                              ></div>
                            </div>
                          </div>
                        ) : (
                          <div className="w-full h-full rounded-lg bg-red-100 flex flex-col items-center justify-center text-red-600 text-sm">
                            <p>Failed</p>
                            <button
                              onClick={() =>
                                setUploadStatuses((prev) =>
                                  prev.filter((s) => s.id !== status.id)
                                )
                              }
                              className="mt-2 text-xs text-blue-600 underline"
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              )}

              {mediaItems.length === 0 && uploadStatuses.length === 0 && (
                <div className="flex flex-col justify-center items-center relative z-10 bg-[#EDF4F94D] p-5 rounded-xl">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-8 h-8 text-gray-400"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 
                              2.25 0 0021 18.75V16.5m-3-6l-6-6m0 
                              0l-6 6m6-6V15"
                    />
                  </svg>
                  <p className="text-gray-600 mt-2 text-fs_14">
                    Drag & drop image or{" "}
                    <label className="inline-block text-primary  rounded cursor-pointer">
                      Browse Files
                      <input
                        type="file"
                        multiple
                        accept="image/*,video/*"
                        className="hidden"
                        onChange={(e) =>
                          handleFileChange(e, form.setFieldValue, values)
                        }
                      />
                    </label>
                  </p>
                </div>
              )}
            </div>
          </div>
        );
      }}
    </Field>
  );
};
